<template>
    <div class="animated fadeIn">
        <div class="app flex-row align-items-center">
            <div class="container">
                <b-row class="justify-content-center">
                    <b-col md="6">

                        <Request
                                ref="requestNewPassword"
                                method="POST"
                                :options="{ blockOnProcessing: false, showAlert: false }"
                                :onRequestSuccess="requestPasswordRecoverySuccess"
                                :onRequestError="requestPasswordRecoveryError"
                                root="/user/password-recovery">
                            <slot slot="body">
                                <b-card-group>
                                    <b-card no-body class="p-4">
                                        <b-card-body>
                                            <b-form>
                                                <div>
                                                    <img class="mb-4" :width="Core.Session.Setting.getSetting('environment.ui.login.logoWidth', '200px')"
                                                         :src="Core.Session.Setting.getSetting('environment.ui.login.logo', Core.Session.Setting.getSetting('environment.ui.logoFull'))">
                                                </div>
                                                <h4>{{Core.Definition.getDefinition('Récupération du mot de passe')}}</h4>
                                                <p class="text-muted">
                                                    {{Core.Definition.getDefinition('Confirmez votre nouveau mot de passe')}}</p>
                                                <b-input-group class="mb-2">
                                                    <b-form-input v-model="dataUser.password" type="password" class="form-control"
                                                                  :placeholder="Core.Definition.getDefinition('Nouveau mot de passe')" />
                                                </b-input-group>
                                                <b-input-group class="mb-4">
                                                    <b-form-input v-model="dataUser.confirm" type="password" class="form-control"
                                                                  :placeholder="Core.Definition.getDefinition('Confirmation du mot de passe')" />
                                                </b-input-group>
                                                <Alert :alert="dataAlert"></Alert>
                                                <b-row>
                                                    <b-col cols="12">
                                                        <b-button variant="primary" @click="login" class="mr-2">
                                                            <i class="fa fa-chevron-left"></i>
                                                        </b-button>
                                                        <b-button :disabled="dataProcessing" variant="primary" @click="passwordRecovery" class="px-4">
                                                            <i  v-if="dataProcessing" class="fa fa-spin fa-spinner mr-1"></i>{{Core.Definition.getDefinition('Confirmer')}}
                                                        </b-button>
                                                    </b-col>
                                                </b-row>
                                            </b-form>
                                        </b-card-body>
                                    </b-card>
                                </b-card-group>
                            </slot>
                        </Request>

                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
    import Request from '../components/Request'
    import Alert from '../components/Alert'
    import CryptoJS from 'crypto-js'
    export default {
        name: 'NewPassword',
        components: {
            Request,
            Alert
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataProcessing: false,
                dataUser: {
                    password: '',
                    confirm: ''
                },
                dataAlert: {}
            }
        },
        methods: {
            passwordRecovery() {
                this.dataAlert.show = false
                if (this.dataUser.password === this.dataUser.confirm) {
                    this.dataProcessing = true
                    let password = CryptoJS.MD5(this.dataUser.password).toString()
                    let confirm = CryptoJS.MD5(this.dataUser.confirm).toString()
                    let signature = this.$route.params.signature
                    let email = this.$route.params.email
                    this.$refs.requestNewPassword.addArg('password', password)
                    this.$refs.requestNewPassword.addArg('confirm', confirm)
                    this.$refs.requestNewPassword.addArg('signature', signature)
                    this.$refs.requestNewPassword.addArg('email', email)
                    this.$refs.requestNewPassword.request()
                } else {
                    this.dataAlert = {
                        variant: 'danger',
                        show: true,
                        message: Core.Definition.getDefinition('Votre nouveau mot de passe et la confirmation doivent être identique.')
                    }
                }

            },
            requestPasswordRecoverySuccess(data) {
                this.dataProcessing = false
                if (data.alert!==undefined) {
                    this.dataAlert = data.alert
                } else {
                    this.login()
                }
            },
            requestPasswordRecoveryError(data) {
            },
            login() {
                this.$router.push(Core.Definition.getDefinition('/connexion'))
            }
        }
    }
</script>
